import usuarioSemDominioIdCondition from './UsuarioSemDominioIdCondition'

export default {
    usuarioSemDominioIdCondition
}
